<div class="btn-wrapper">
  <a class="explore-btn" [routerLink]="['/explore']">
  <!-- <a class="explore-btn" (click)="goToMobileApp()"> -->
  <!-- <a class="explore-btn"> -->
    <div style="display: flex; align-items: center;">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 136">
        <path id="Vector" d="M8.98927 17.0779C13.4566 17.0779 17.0781 13.4563 17.0781 8.98893C17.0781 4.52153 13.4566 0.899994 8.98927 0.899994C4.5219 0.899994 0.900391 4.52153 0.900391 8.98893C0.900391 13.4563 4.5219 17.0779 8.98927 17.0779Z" stroke="#9393AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path id="Vector_2" d="M19.1005 19.1L14.7021 14.7016" stroke="#9393AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
      </svg>
    </div>
    <div>
      <div class="top">
        <ng-container i18n>Where are you hopping?</ng-container>
      </div>
      <div class="bottom">
        <ng-container i18n>Anywhere  •  Any Week  •  Add Guests</ng-container>
      </div>
    </div>
    <div class="icon-end">
      <!-- <a [routerLink]="['/filters']"> -->
      <a>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Group 941">
          <path id="Vector" d="M7.50002 3.75002L18.75 3.75002" stroke="#9393AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path id="Vector_2" d="M1.25002 16.25H12.5" stroke="#9393AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <circle id="Ellipse 15" cx="3.74999" cy="3.75001" r="2.99999" stroke="#9393AA" stroke-width="1.5"/>
          <circle id="Ellipse 16" cx="16.25" cy="16.25" r="2.99999" stroke="#9393AA" stroke-width="1.5"/>
          </g>
        </svg>
      </a>
    </div>
  </a>
</div>
